import { useEffect } from "react";
import { options } from "../utils/tmdbToken";
import { useDispatch, useSelector } from "react-redux";
import { addMovie } from "../utils/movieSlice";

const useMovieList = () => {

  const nowplaying=useSelector(store=>store.movie.addMovie)
  const dispatch=useDispatch()
  const getMovieList = async () => {
    const data = await fetch(
      "https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1",
      options
    );
    const json = await data.json();
    dispatch(addMovie(json.results))
    
    
  };

  useEffect(() => {
   !nowplaying && getMovieList();
  }, []);

};
export default useMovieList;
